.assistantWandIcon {
  color: var(--aha-amethyst-400);
  font-size: 18px;
}

.assistantWandIconPromo {
  color: var(--theme-primary-text);
}

.assistantMenuBottomBar {
  display: flex;
  justify-content: space-between;
  padding-left: var(--aha-menu-group--padding-vertical);
}

.assistantBackForward {
  display: flex;
  align-items: center;
}

.assistantImageUploadButton {
  display: flex;
  align-items: center;
}

/* https://chriscoyier.net/2023/09/29/css-solves-auto-expanding-textareas-probably-eventually/ */
.assistantPromptGrow {
  display: grid;
  flex: 1;
  max-height: 80px;
  overflow: auto;
}

.assistantPromptGrow::after {
  /* Note the weird space! Needed to preventy jumpy behavior */
  content: attr(data-replicated-value) ' ';

  /* This is how textarea text behaves */
  white-space: pre-wrap;

  /* Hidden from view, clicks, and screen readers */
  visibility: hidden;
}

.assistantPromptGrow > .assistantPrompt,
.assistantPromptGrow::after {
  /* Identical styling required!! */
  padding: 0.5rem;
  font: inherit;
  width: auto;

  border: none;
  outline: none;
  margin-bottom: 0px;
  resize: none;
  min-height: 20px;
  line-height: 20px;

  /* Place on top of each other */
  grid-area: 1 / 1 / 2 / 2;
}

.assistantPrompt:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}
